import React from "react";
import { Store } from "../../service/Store";
import Lang from "../../service/Lang";
import { RouteComponentProps } from "react-router";
import { APIBase, Device, DeviceOutput } from "../../service/API";
import { arrowBack, arrowDown, arrowUp, reload } from "ionicons/icons";
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonLoading, IonPage, IonText, IonTitle, IonToolbar } from "@ionic/react";
import { inject } from "mobx-react";
import './Style.css';


export interface DeviceOutputServiceContadorProps extends RouteComponentProps<{ id: string, output: string }> {
    store?: Store;
    lang?: Lang;
    routerOutlet: HTMLIonRouterOutletElement,
}
export interface DeviceOutputServiceContadorState {
    device?: Device,
    output?: DeviceOutput,
    loading?: boolean,
    error?: string,

    pantallaContador1?: string;
    pantallaContador2?: string;
    numeroPantalla?: string;
    keyToInput?: string;

}


@inject("store", "lang")
export default class DeviceOutputServiceContador extends React.Component<DeviceOutputServiceContadorProps, DeviceOutputServiceContadorState> {

    state: Readonly<DeviceOutputServiceContadorState> = {} as DeviceOutputServiceContadorState;



    componentDidMount(): void {
        let id = parseInt(this.props.match.params.id);
        this.loadDevice(id);
    }

    componentDidUpdate(prevProps: Readonly<DeviceOutputServiceContadorProps>, prevState: Readonly<DeviceOutputServiceContadorState>, snapshot?: any): void {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.loadDevice(parseInt(this.props.match.params.id));
        }

    }

    loadDevice(id: number) {
        this.props.store!.api.deviceGet(id, 'outputModbus').then((value: APIBase<Device>) => {
            if (value.success) {
                let output_id = parseInt(this.props.match.params.output);
                let output = value.data.outputs.find((a) => a.id === output_id);
                this.setState({ device: value.data, output: output }, () => {
                    if (output) {
                        if (output.outputService) {
                            this.updateCommand();
                        } else {
                            this.setState({ loading: false, error: 'No se ha configurado el servicio: No hay salida asociada' });
                        }
                    } else {
                        this.setState({ loading: false, error: 'Inposible obtener la salida' });
                    }
                });

            } else {
                this.setState({ loading: false, error: 'Inposible obtener la información' });
            }
        });
    }

    updateCommand() {
        this.queryModbus(256, 32).then((value: any) => {
            if (value.modbusResponse) {
                let array: number[] = value.modbusResponse;

                // Array of WORD, convert to ASCII. Bigendian.
                let str = "";
                for (let index = 0; index < array.length; index++) {
                    const element = array[index];
                    let a = element & 0xFF;
                    let b = (element >> 8) & 0xFF;

                    if (a !== 0) {
                        str += String.fromCharCode(a);
                    } else {
                        str += " ";
                    }
                    if (b !== 0) {
                        str += String.fromCharCode(b);
                    } else {
                        str += " ";
                    }

                    if (index === 15) {
                        this.setState({ pantallaContador1: str });
                        str = "";
                    }
                }
                this.setState({ pantallaContador2: str });
            }

            console.log(value);
        });

    }
    changeScreenCommand(screenId: number) {
        this.writeModbus(59, screenId).then((value: any) => {
            // @ts-ignore
            if (window.confirm("¿Desea recargar la pantalla?")) {
                this.updateCommand();
            }
        });

    }
    inputKey(key: number) {
        this.writeModbus(58, key).then((value: any) => {
            // @ts-ignore
            if (window.confirm("¿Desea recargar la pantalla?")) {
                this.updateCommand();
            }
        });

    }

    queryModbus(addr: number, size: number) {
        return new Promise((resolve, reject) => {
            let output = this.state.output as DeviceOutput;

            if (!output.modbusRead) {

                this.setState({ loading: false, error: 'No se ha configurado el servicio: No hay funcion modbus de lectura.' });
                return;
            }
            let modbus = { ...output.modbusRead };
            modbus.address = addr;
            modbus.registers = size;
            modbus.dataFormat = 1;

            this.setState({ loading: true, error: "" });

            this.props.store!.api.deviceModbusQuery(this.state.device!.id!, modbus).then((value: APIBase<any>) => {
                if (value.success) {
                    this.setState({ loading: false, error: "" });
                    resolve(value.data);
                } else {
                    this.setState({ loading: false, error: 'Inposible obtener la información' });
                }
            });
        });

    }
    writeModbus(addr: number, data: number) {
        return new Promise((resolve, reject) => {
            let output = this.state.output as DeviceOutput;

            if (!output.modbusRead) {

                this.setState({ loading: false, error: 'No se ha configurado el servicio: No hay funcion modbus de lectura.' });
                return;
            }
            let modbus = { ...output.modbusRead };
            modbus.address = addr;
            modbus.registers = 1;
            modbus.functionCode = 6;
            modbus.dataFormat = 1;
            modbus.value = data;

            this.setState({ loading: true, error: "" });

            this.props.store!.api.deviceModbusQuery(this.state.device!.id!, modbus).then((value: APIBase<any>) => {
                if (value.success) {
                    this.setState({ loading: false, error: "" });
                    resolve(value.data);
                } else {
                    this.setState({ loading: false, error: 'Inposible obtener la información' });
                }
            });
        });

    }
    renderLoading() {
        // const { lang } = this.props;
        return <IonLoading
            isOpen={this.state.loading!}
            message={"Descargando datos de estacion..."}
        />
    }

    renderContador() {
        if (this.state.pantallaContador1) {
            return <div className="vt323-regular pantalla-contador">
                {this.state.pantallaContador1}<br />
                {this.state.pantallaContador2}<br />

            </div>;
        }
        return "";

    }

    render(): React.ReactNode {
        return <IonPage>


            <IonHeader color={"secondary"}>
                <IonToolbar color={"primary"}>
                    <IonButtons slot="start">
                        <IonButton routerDirection={"back"} routerLink={"/device/" + this.props.match.params.id + "/details"} ><IonIcon icon={arrowBack} /></IonButton>
                    </IonButtons>
                    <IonTitle>{this.state.device?.name} - {this.state.output?.name} </IonTitle>

                    <IonButtons slot="end">
                        <IonButton onClick={() => this.updateCommand()}><IonIcon icon={reload} /></IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent scrollEvents={true}>
                {/* {this.state.stationData && this.renderStation(this.state.stationData)} */}


                {this.state.error && <IonText>{this.state.error}</IonText>}
                {this.renderLoading()}
                {this.renderContador()}
                <IonList>
                    <IonItem>
                        <IonInput labelPlacement="floating" label="Número de pantalla (0-50+)" value={this.state.numeroPantalla} onIonInput={(ev) => this.setState({ numeroPantalla: ev.detail.value! })}></IonInput>

                    </IonItem>
                    <IonItem>
                        <IonButton onClick={() => this.changeScreenCommand(parseInt(this.state.numeroPantalla!))}>Cambiar pantalla</IonButton>

                    </IonItem>
                    <IonItem>
                        <IonInput labelPlacement="floating" label="Key To Input" value={this.state.keyToInput} onIonInput={(ev) => this.setState({ keyToInput: ev.detail.value! })}></IonInput>

                    </IonItem>
                    <IonItem>
                        <IonButton onClick={() => this.inputKey(parseInt(this.state.keyToInput!))}>OK</IonButton>
                    </IonItem>
                    <IonItem>
                        <IonLabel>Teclado Virtual</IonLabel>
                    </IonItem>
                    <IonItem lines="none">
                        <IonButton onClick={() => this.inputKey(1)}>1</IonButton>
                        <IonButton onClick={() => this.inputKey(2)}>2</IonButton>
                        <IonButton onClick={() => this.inputKey(3)}>3</IonButton>
                        <IonButton onClick={() => this.inputKey(4)}>4</IonButton>
                        <IonButton onClick={() => this.inputKey(5)}>5</IonButton>
                        
                    </IonItem>
                    <IonItem lines="none">
                        <IonButton onClick={() => this.inputKey(6)}>6</IonButton>
                        <IonButton onClick={() => this.inputKey(7)}>7</IonButton>
                        <IonButton onClick={() => this.inputKey(8)}>8</IonButton>
                        <IonButton onClick={() => this.inputKey(9)}>9</IonButton>
                        <IonButton onClick={() => this.inputKey(16)}>0</IonButton>
                        
                    </IonItem>
                    <IonItem>
                        <IonButton onClick={() => this.inputKey(10)}>.</IonButton>
                        <IonButton onClick={() => this.inputKey(11)}> <IonIcon icon={arrowBack}></IonIcon> </IonButton>
                        <IonButton onClick={() => this.inputKey(14)}><IonIcon icon={arrowUp}></IonIcon> / +</IonButton>
                        <IonButton onClick={() => this.inputKey(15)}><IonIcon icon={arrowDown}></IonIcon> / -</IonButton>
                        <IonButton onClick={() => this.inputKey(12)}>MENU</IonButton>
                        <IonButton onClick={() => this.inputKey(13)}>ENT</IonButton>
                        
                    </IonItem>
                </IonList>

            </IonContent>
        </IonPage>
    }
}